import Vue from "vue";

export default class FetchService {
	getPageData(APIUrl, pageID) {
		return Vue.http.get(APIUrl + "/Pages?id=" + pageID);
	}
	getTextBlock(APIUrl, blockName) {
		return Vue.http.get(APIUrl + "/textblocks?filter[name]=" + blockName);
	}
}



// WEBPACK FOOTER //
// ./src/services/FetchService.js